import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '../constants-enumerate';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../i18n';

/**
 * @summary JobsStatus
 * @extends {i18nMixin(mapStatePropertiesMixin(AoflElement))}
 */
@customElement('jobs-status')
class JobsStatus extends i18nMixin(mapStatePropertiesMixin(AoflElement)) {
  /**
   * Creates an instance of JobsStatus.
   */
  constructor() {
    super();

    this.storeInstance = storeInstance;
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static is = 'jobs-status';

  @property({type: Array, attribute: false})
  jobs = [];

  @property({type: Array, mapState: `${sdoNs.SESSION}.locale`, store: storeInstance})
  locale = '';

  mapStateProperties() {
    const state = this.storeInstance.getState();
    this.jobs = state[sdoNs.USER_JOBS].$activeJobs;
  }

  dismiss(id) {
    storeInstance.commit({
      namespace: sdoNs.USER_JOBS,
      mutationId: 'setDismissedJob',
      payload: id
    });
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default JobsStatus;
